import React from "react";
import "../Styles/Footer.css";

// Example imports – use your actual paths
import googlePlay from "../assests/images/google-play.png";
import appStore from "../assests/images/app-store.png";
import customLogo from "../assests/images/custom-logo.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-logos">
          <img src={googlePlay} alt="Google Play" />
          <img src={appStore} alt="App Store" />
          
        </div>
        <div className="footer-copy">
         <img  className="footer-copy" src={customLogo} alt="Custom Logo" />
        </div>
      </div>
      <div className="footer-line" />
    </footer>
  );
}
